module.exports = __webpack_public_path__ + "static/media/paint.8f0e4db9.png";